import React from 'react';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    PointElement,
    LineElement,
    Legend,
    Title,
    Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Legend,
    Title,
    Tooltip
);

const LineGraph = React.forwardRef((props, ref) => {
    const options = {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: props.text,
            },
        },
        scales: {
            x: { stacked: props.stack },
            y: { stacked: props.stack, ticks: { beginAtZero: true } },
        },
    };

    return <Line ref={ref} data={props.data} options={options} />;
});

export default LineGraph;
